import React, { useEffect, useRef, useState } from 'react';
import { Eraser } from 'lucide-react';

// Small draw-with-finger/mouse signature box; returns a PNG data URL (or null when cleared)
export const SigPad = ({ label, onChange, testid }) => {
  const ref = useRef(null);
  const drawing = useRef(false);
  const [has, setHas] = useState(false);
  useEffect(() => {
    const c = ref.current;
    const ctx = c.getContext('2d');
    ctx.lineWidth = 2.2; ctx.lineCap = 'round'; ctx.strokeStyle = '#0b1f5c';
  }, []);
  const pos = (e) => { const r = ref.current.getBoundingClientRect(); const p = e.touches ? e.touches[0] : e; return [(p.clientX - r.left) * (ref.current.width / r.width), (p.clientY - r.top) * (ref.current.height / r.height)]; };
  const start = (e) => { e.preventDefault(); drawing.current = true; const ctx = ref.current.getContext('2d'); ctx.beginPath(); ctx.moveTo(...pos(e)); };
  const move = (e) => { if (!drawing.current) return; e.preventDefault(); const ctx = ref.current.getContext('2d'); ctx.lineTo(...pos(e)); ctx.stroke(); };
  const end = () => { if (!drawing.current) return; drawing.current = false; setHas(true); onChange(ref.current.toDataURL('image/png')); };
  const clear = () => { ref.current.getContext('2d').clearRect(0, 0, ref.current.width, ref.current.height); setHas(false); onChange(null); };
  return (
    <div className="space-y-1">
      <div className="flex items-center justify-between h-5 text-xs text-gray-600"><span>{label}</span>
        {has && <button onClick={clear} className="inline-flex items-center gap-1 hover:text-red-600" data-testid={`${testid}-clear`}><Eraser className="w-3 h-3" />Clear</button>}</div>
      <canvas ref={ref} width={500} height={105} data-testid={testid}
        className="w-full h-[84px] border border-dashed border-gray-400 rounded bg-white touch-none cursor-crosshair"
        onMouseDown={start} onMouseMove={move} onMouseUp={end} onMouseLeave={end} onTouchStart={start} onTouchMove={move} onTouchEnd={end} />
    </div>
  );
};
